/* istanbul ignore file */
import React from 'react';
import { ShowData, ShowContextProvider } from 'framework/show';
import { ResourceData } from 'framework/crud';

type TimelineRecordWrapperProps = {
  entity: ResourceData;
  children: React.ReactElement;
};

const TimelineRecordWrapper = ({ entity, children }: TimelineRecordWrapperProps) => {
  const dataInstance = new ShowData(entity);

  return (
    <ShowContextProvider
      value={{
        data: dataInstance,
      }}
    >
      {children}
    </ShowContextProvider>
  );
};

export default TimelineRecordWrapper;
